import { DatePipe } from '@angular/common';
import { Component, ElementRef, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { NgxSpinnerService } from 'ngx-spinner';
import { CommonService } from 'src/app/services/common.service';
import { MeetingMatrixService } from 'src/app/services/meeting-matrix.service';
import { OverallActionPlanService } from 'src/app/services/overall-actionPlan.service';
import { ImageDialogComponent } from 'src/app/analytical-tools/image-dialog/image-dialog.component';
import {
  differenceInCalendarDays,
  endOfMonth,
  startOfMonth,
  startOfYesterday,
} from 'date-fns';
import { DatepickerService } from 'src/app/services/Datepicker.service';
import * as moment from 'moment';
import { ActivatedRoute } from '@angular/router';
import { GridSizeChangedEvent } from 'ag-grid-community';
import { ToastrService } from 'ngx-toastr';
import { MeetingEvaluationService } from 'src/app/services/meeting-evaluation.service';
import { EmployeeService } from 'src/backend/services/user-access-services/employee.service';
import { Constants } from 'src/@smartmanufacturing/common/constants';

@Component({
  selector: 'app-meeting-evaluation-level',
  templateUrl: './meeting-evaluation-level.component.html',
  styleUrls: ['./meeting-evaluation-level.component.scss']
})
export class MeetingEvaluationLevelComponent implements OnInit {
  @ViewChild('actionPlanModal') private actionPlanModal!: TemplateRef<any>;
  @ViewChild('fileInput') fileInput!: ElementRef;
  @ViewChild('fileInputFile') fileInputFile!: ElementRef;

  gridApi: any;
  gridColumnApi: any;
  modules: any;
  components: any;
  columnDefs: any;
  columnDefs1: any;
  rowData: any[] = [];
  bottomData: any;
  MeetingEvaluationForm!: FormGroup;
  meetingMasterId = 0;
  leaderId = 0;
  rowSpanCount = 0;
  average = 0;
  isSaving = false;
  successMessage = '';
  paramValues: any = {
    plant: 0,
    meeting: 0,
    meetingAttendId: 0,
    participantId: 0,
    group: 0
  };
  isEvaluationFilled = false;

  doc: string;
  blobStorageUrl: string = Constants.BLOB_STORAGE_URL;
  images: any[] = [];
  fileType: string;
  fileDesc: any;
  displayMaximizable: boolean;
  headerId: any;
  data: any;
  ImageSave: any;
  fileSave: any;
  closefile: any;
  currentNodeDate: any;
  currentAssigneeEmail: any;
  currentResponsibleEmail: any;
  ModuleName: any;
  UniqueCode: any;
  editActionPlanForm!: FormGroup;
  disableVerification: boolean;
  disableNewAssigne: boolean;
  targetDate: string | number | Date;
  currentDialog: any;
  overallMeetingActions: any[]
  rowData1: any[] = [];
  columnDefsallAction: any;
  addActionForm!: FormGroup;
  kpiName: string = '';
  userList: any = [];
  participantsByPlants: any[];
  imageFile: any;
  imageSrc: string;
  RevisedDate: string | number | Date;
  Status: string;
  plants!: any;
  calendarPlantId: any;
  firstDayOfWeek: any;
  shiftData: any[] = [];
  showinput: boolean;
  disableForm: boolean = false;

  constructor(private fb: FormBuilder, private toaster: ToastrService,
    private meetingEvaluationService: MeetingEvaluationService,
    private dialog: MatDialog,
    private meetingService: MeetingMatrixService,
    private datePipe: DatePipe,
    private actionplanService: OverallActionPlanService,
    private spinner: NgxSpinnerService,
    private datepickerService: DatepickerService,
    private commonService: CommonService,
    private employeeService: EmployeeService,
    private route: ActivatedRoute) {
    this.MeetingEvaluationForm = this.fb.group({
      meeting: [''],
      date: [''],
      leader: ['']
    });
    this.columnDefs = [
      {
        field: 'area',
        wrapText: true,
        resizable: true,
        cellRenderer: (params: any) => {
          if (params.value && params.value.name) {
            return '<div class="area-name">' +
              params.value.name +
              '' +
              '</div>';
          } else { return ''; }
        },
        headerName: 'Level',
        rowSpan: this.rowSpan,
        cellClassRules: { 'show-cell': 'value !== undefined' },
        cellStyle: (params: any) => {
          if (params.value && params.value.name) {
            return { background: '#49FFB9', border: '1px solid #333' };
          } else {
            return { background: 'white' };
          }
        },
        width: 150,
      },
      { field: 'detail', headerName: 'Check Detail', width: '390' },
      {
        field: 'score', headerName: 'Evaluation Result', width: '200', editable: true,
        onCellValueChanged: (params: any) => this.getAverage(params),
        cellRenderer: 'agCellRenderer',
        cellEditor: 'agRichSelectCellEditor',
        cellEditorParams: {
          cellRenderer: 'genderCellRenderer',
          values: ['Ok', 'Not Ok'],
        },
        cellStyle: {
          color: '#000000',
          'background-color': '#EDF1E5',
        }
      },
      {
        field: 'avg',
        headerName: 'Average',
        rowSpan: this.rowSpan,
        cellClassRules: { 'show-cell': 'value !== undefined' },
        cellStyle: (params: any) => {
          if (params.data.area && params.data.area.name) {
            return { background: '#49FFB9', border: '1px solid #333', fontWeight: 'bold', fontSize: '30px' };
          } else {
            return { background: 'white' };
          }
        },
        width: 150,
      },
      {
        field: 'xyz',
        headerName: 'Average',
        hide: true,
        rowSpan: (params: { data: { xyz: any; }; }) => params.data.xyz !== undefined,
        width: 150,
      },
    ];
    this.editActionPlanForm = this.fb.group({
      id: [''],
      remarks: [''],
      closefile: [''],
      revisedDate: [''],
      actions: [''],
      assignTo: [''],
      completed: ['No'],
      verification: [''],
      actionType: [''],
      targetDate: [''],
      NewAssignee: [''],
      rootcause: ['']
    });
    this.columnDefsallAction = [
      {
        field: 'actions',
        headerName: 'Actions',
        width: 100,
        resizable: true,
        filter: true,
        cellRenderer: (params: any): any => {
          if (params.data.Status !== 'Closed') {
            return `
            <div>
            <button mat-mini-fab=""
            color="primary"
            ptooltip="Action Delete"
            title="Edit Action"
            tooltipposition="top"
            class="viewRCA mat-focus-indicator mat-mini-fab mat-button-base mat-primary" ng-reflect-color="primary"><span class="mat-button-wrapper"><mat-icon role="img" class="mat-icon notranslate material-icons mat-icon-no-color" aria-hidden="true" data-mat-icon-type="font">edit</mat-icon></span><span matripple="" class="mat-ripple mat-button-ripple mat-button-ripple-round" ng-reflect-disabled="false" ng-reflect-centered="false" ng-reflect-trigger="[object HTMLButtonElement]"></span><span class="mat-button-focus-overlay"></span></button>
             </div>
          `;
          }
        },
      },
      {
        field: 'RootCause',
        headerName: 'Root Cause',
        resizable: true,
        filter: true,
      },
      {
        field: 'Action',
        headerName: 'Meeting Action',
        resizable: true,
        filter: true,
        width: 150,
      },
      {
        field: 'KPIName',
        headerName: 'KPI Name',
        resizable: true,
        filter: true,
      },
      {
        field: 'Status',
        headerName: 'Status',
        resizable: true,
        filter: true,
        width: 100,
        cellStyle: function (params: any): any {
          if (params.value == 'Open')
            return { color: 'white', backgroundColor: 'gray' };
          else if (params.value == 'InProgress')
            return { color: 'white', backgroundColor: 'orange' };
          else if (params.value == 'Complete')
            return { color: 'white', backgroundColor: '#1cd51c' };
          else if (params.value == 'Closed')
            return { color: 'white', backgroundColor: 'green' };
          else if (params.value == 'Delayed')
            return { color: 'white', backgroundColor: 'brown' };
          else if (params.value == 'Rejected')
            return { color: 'white', backgroundColor: 'red' };
        },
      },
      {
        field: 'AssignedDate',
        headerName: 'Assigned Date',
        resizable: true,
        filter: true,
        valueFormatter: function (params) {
          return params.value
            ? moment(params.value).format('MMMM d, YYYY')
            : params.value;
        },
        width: 150,
      },
      {
        field: 'AssingedBy',
        headerName: 'Assigned By',
        resizable: true,
        width: 150,
        filter: true,
      },
      {
        field: 'TargetDate',
        headerName: 'Target Date',
        resizable: true,
        filter: true,
        valueFormatter: function (params) {
          return params.value
            ? moment(params.value).format('MMMM d, YYYY')
            : params.value;
        },
        width: 150,
      },
      {
        field: 'NoOfMisses',
        headerName: 'No of Misses',
        resizable: true,
        filter: true,
      },
      {
        field: 'RevisedDate',
        headerName: 'New Target Date',
        resizable: true,
        filter: true,
        valueFormatter: function (params) {
          return params.value
            ? moment(params.value).format('MMMM d, YYYY')
            : params.value;
        },
        width: 150,
      },
      {
        field: 'ActionCompleted',
        headerName: 'Completed',
        filter: true,
        resizable: true,
        width: 130,
      },
      {
        field: 'ClosedFile',
        headerName: 'Closed File',
        sortable: true,
        resizable: true,
        filter: true,
        cellRenderer: function (params: any) {
          let html = '';
          if (params && params.value) {
            html = `<button mat-mini-fab=""
             color="primary"
             ptooltip="View document"
             title="View document"
             tooltipposition="top"
             class="viewDocument mat-focus-indicator mat-mini-fab mat-button-base mat-primary" ng-reflect-color="primary"><span class="mat-button-wrapper"><mat-icon role="img" class="viewDocument mat-icon notranslate material-icons mat-icon-no-color" aria-hidden="true" data-mat-icon-type="font">visibility</mat-icon></span><span matripple="" class="viewDocument mat-ripple mat-button-ripple mat-button-ripple-round" ng-reflect-disabled="false" ng-reflect-centered="false" ng-reflect-trigger="[object HTMLButtonElement]"></span><span class="mat-button-focus-overlay"></span></button>
            `;
          }
          return html;
        },
      },
      {
        field: 'Remarks',
        headerName: 'Remarks',
        resizable: true,
        filter: true,
      },
    ];
    this.addActionForm = this.fb.group({
      id: [''],
      action: ['', Validators.required],
      actionType: ['', Validators.required],
      assignTo: ['', Validators.required],
      targetDate: ['', Validators.required],
      kpi: [''],
    });
  }
  ngOnInit(): void {
    this.route.queryParams
      .subscribe((param: any) => {
        this.paramValues.plant = param?.plant ? (param?.plant) : 0;
        this.paramValues.meeting = param?.meeting ? parseInt(param?.meeting, 10) : 0;
        this.paramValues.meetingAttendId = param?.meetingAttendId ? parseInt(param?.meetingAttendId, 10) : 0;
        this.paramValues.participantId = param?.participantId ? (param?.participantId) : 0;
      });
    this.getMeetingDefinations();
    this.getParticipantsOnPlant();
    this.getOverallMeetingActions();
    this.getPlantByGroup();
  }

  getMeetingDefinations(): void {

    const key = {
      plantId: this.paramValues.plant,
      meetingId: this.paramValues.meeting,
      meetingAttendId: this.paramValues.meetingAttendId,
      participantId: this.paramValues.participantId
    };
    this.meetingEvaluationService.getAllMeetingEvaluationActions(key).subscribe(res => {
      this.meetingMasterId = res?.meetingMasterId;
      this.leaderId = res?.leaderId;
      //  setting values in form group
      this.MeetingEvaluationForm.get('meeting')?.setValue(res?.meetingDefName);
      this.MeetingEvaluationForm.get('leader')?.setValue(res?.leaderName);
      this.MeetingEvaluationForm.get('date')?.setValue(new Date());
      this.isEvaluationFilled = res?.isEvaluation;
      //Write this To disbale Meeting Evaluation Form When User Already orSave Record One time    -- Code Start
      if (this.isEvaluationFilled) {
        this.disableForm = true;
      }

      //Write this To disbale Meeting Evaluation Form When User Already orSave Record One time    -- Code End

      // getting thte unique areas from response
      const uniqueAreas = [... new Set(res?.detail?.map((item: any) => {
        return item.name;
      }))];
      // formate data according to the ag grid
      const formattedArray: any[] = [];
      uniqueAreas.forEach(area => {
        const filteredArray = res?.detail.filter((x: any) => x?.name === area);
        if (filteredArray.length > 0) {
          filteredArray.forEach((meeting: any) => {
            const areafound = formattedArray.findIndex((item: any) => {
              return item?.area?.name === area;
            });
            if (areafound === -1) {
              formattedArray.push({
                area: {
                  name: area
                },
                detail: meeting?.detail,
                score: 'Not Ok',
                totalcount: filteredArray?.length,
                level: area
              });
            } else {
              formattedArray.push({
                detail: meeting?.detail,
                score: 'Not Ok',
                totalcount: filteredArray?.length,
                level: area
              });
            }
          });
        }
      });
      // setting formatted data in ag grid
      this.rowData = formattedArray;

    }, ({ error }) => {
      this.toaster.error(error.message);
    });
  }


  getAverage(params: any): void {

    let counter = 0;
    const filteredlevel = this.rowData.filter((obj: any) => obj.level === params.data.level);
    // tslint:disable-next-line:prefer-for-of
    for (let i = 0; i < filteredlevel.length; i++) {
      if (filteredlevel[i].score === 'Ok')
        counter++;
      this.average = (counter / params.data.totalcount) * 100;
      const a = this.rowData.findIndex(c => c.area === filteredlevel[0].area);
      params.node.setDataValue('xyz', this.average);
      // tslint:disable-next-line:no-non-null-assertion
      const rowNode = this.gridApi.getRowNode(a)!;
      rowNode.setDataValue('avg', this.average.toFixed(2) + '%');
    }

  }
  saveRecord(): void {
    this.isSaving = true;
    const data = {
      meetingMasterId: this.meetingMasterId,
      date: this.MeetingEvaluationForm.value.date,
      leaderId: this.leaderId,
      meetingAttendId: this.paramValues.meetingAttendId,
      participantId: this.paramValues.participantId,
      details: this.rowData?.map((item) => {
        return {
          evaluationResult: item?.score === 'Ok' ? true : false,
          average: item?.xyz,
          evalutionLevel: item?.level
        };
      })
    };
    this.meetingEvaluationService.addEvaluationResult(data).subscribe(res => {
      this.successMessage = 'Thanks for your feedback';
      this.getMeetingDefinations();
      this.isSaving = false;
    }, ({ error }) => {
      this.toaster.error(error.message);
      this.isSaving = false;
    });
  }
  rowSpan(params: any): any {
    if (params.data.area) {
      return params.data.totalcount;
    } else {
      return 1;
    }
  }
  onGridReady(params: any): any {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    this.gridApi.setDomLayout('autoHeight');

    const element: HTMLElement = document.querySelector('#agGrid') as HTMLElement;
    if (element !== null) {
      element.style.height = '';
    }
  }
  onGridSizeChanged(params: GridSizeChangedEvent): any {
    params.api.sizeColumnsToFit();
  }
  getOverallMeetingActions() {
    const data = {
      meetingId: this.paramValues.meeting,
    };
    this.meetingService.getAllMeetingActions(data).subscribe(
      (response) => {
        this.rowData1 = response;
        this.overallMeetingActions = response;
        //this.createLineAndStackChart(response);
      },
      (err: any) => {

      }
    );
  }

  cellClickedActionTable(params: any) {
    let col = params.colDef.field;

    let classList = params.event.target.classList;
    if (col === 'actions') {
      if (
        classList.contains('mat-icon-no-color') ||
        classList.contains('viewRCA')
      ) {
        this.EditRow(params);
      }
    }
    if (col === 'ClosedFile') {
      if (classList.contains('viewDocument')) {
        this.doc =
          this.blobStorageUrl +
          params.data.ClosedFile;
        const fileType = params.data.ClosedFile.split('.').pop();
        if (
          fileType === 'jpeg' ||
          fileType === 'jpg' ||
          fileType === 'png' ||
          fileType === 'gif'
        ) {
          this.images = [];
          this.fileType = 'img';
          this.images.push(this.doc);
        } else {
          this.fileType = 'doc';
        }
        this.fileDesc = params.data?.KPIName;
        this.displayMaximizable = true;
      }
    }
  }
  EditRow(params: any): void {
    this.headerId = params?.data?.HeaderId;
    if (params) {
      this.data = [];
      this.ImageSave = null;
      this.fileSave = null;
      this.closefile = null;
      this.currentNodeDate = params.node.data.ObservedDate;
      this.currentAssigneeEmail = params.node.data.AssigneEmail;
      this.currentResponsibleEmail = params.node.data.ParticpantEmails;
      this.data = params.node.data;
      this.ModuleName = params.node.data.Module;
      this.UniqueCode = params.node.data.UniqueCode;
      this.editActionPlanForm.get('actions').setValue(params.node.data.Action);
      this.editActionPlanForm.get('rootcause').setValue(params.node.data.RootCause);
      this.editActionPlanForm
        .get('assignTo')
        .setValue(params.node.data.AssignTo);
      this.editActionPlanForm
        .get('completed')
        .setValue(params.node.data.ActionCompleted);
      this.editActionPlanForm.get('remarks').setValue(params.node.data.Remarks);
      this.editActionPlanForm.get('remarks').setValue(params.node.data.Remarks);
      this.editActionPlanForm
        .get('NewAssignee')
        .setValue(params.node.data.NewAssigneeId);
      if (params.node.data.ActionCompleted === 'No') {
        this.disableVerification = true;
      }
      if (params.node.data.Verification === 'Disapproved') {
        this.disableNewAssigne = false;
      }
      this.editActionPlanForm
        .get('verification')
        .setValue(params.node.data.Verification);
      this.editActionPlanForm
        .get('actionType')
        .setValue(params.node.data.ActionType);
      if (params.node.data.RevisedDate !== null) {
        this.editActionPlanForm
          .get('revisedDate')
          .setValue(
            this.datePipe.transform(
              new Date(params.node.data.RevisedDate),
              'yyyy-MM-dd'
            )
          );
      }
      if (params.node.data.TargetDate !== null) {
        this.editActionPlanForm
          .get('targetDate')
          .setValue(
            this.datePipe.transform(
              new Date(params.node.data.TargetDate),
              'yyyy-MM-dd'
            )
          );
      }
      this.targetDate = params.node.data.TargetDate;

      if (params.data.UploadFile) {
        this.data.UploadFile = params.data.UploadFile;
      }
      // this.editActionPlanForm.get('targetDate').setValue(params.data.TargetDate) ;
      this.currentDialog = this.dialog.open(this.actionPlanModal, { height: 'auto', width: '90%' });
    }
  }
  addActionPlan(): void {

    let status =
      this.addActionForm.value.targetDate &&
        !this.addActionForm.value.revisedDate
        ? 'InProgress'
        : this.addActionForm.value.targetDate &&
          this.addActionForm.value.revisedDate
          ? 'Delayed'
          : 'Open';
    if (this.addActionForm.value.verification === 'Approved') {
      status = 'Closed';
      // fiveWhy.ClosedDate = new Date();
    } else if (this.addActionForm.value.verification === 'Disapproved') {
      status = 'ReOpened';
      // fiveWhy.ActionCompleted = 'No';
      this.addActionForm.get('completed').setValue('No');
    }
    this.targetDate = this.addActionForm.value.targetDate;
    this.targetDate = new Date(this.targetDate);
    this.targetDate.setHours(new Date().getHours());
    this.targetDate.setMinutes(new Date().getMinutes());
    this.targetDate.setSeconds(new Date().getSeconds());

    const key = {
      actionName: this.addActionForm.value.action,
      actionType: this.addActionForm.value.actionType,
      responsible: this.addActionForm.value.assignTo,
      targetDate: this.targetDate,
      status: status,
      userCode: this.paramValues.participantId,
      // userId: JSON.parse(localStorage.user).UserId,
      // plantId: this.paramValues.plant,
      plantCode: this.paramValues.plant,
      meetingStatus: 1,
      meetingId: this.paramValues.meeting,
      kpiId: 0
    };
    this.spinner.show();
    this.actionplanService.addActionPlan(key).subscribe(({
      next: (res: any) => {
        this.spinner.hide();
        if (res?.data[0]?.message === 'Add Successfully') {
          this.toaster.success('Sucess', 'Added Successfully');
          this.getOverallMeetingActions();
          this.addActionForm.reset();
          this.addActionForm.get('actionType')?.setValue('Corrective');
          this.addActionForm.get('kpi')?.setValue(this.kpiName);
        }
      },
      error: ({ error }) => {
        this.spinner.hide();
        this.toaster.error('Error', '');
      }
    }));
  }
  getParticipantsOnPlant() {
    let data = {
      groupCode: this.paramValues.group,
      plantCode: this.paramValues.plant,
    };

    this.employeeService.getAllEmployees().subscribe(
      (response: any) => {
        if (!response.HasError) {
          // this.orgMachineryList.map((machinery: any) => this.machineryList.push([...this.mList.machineryList]));
          this.participantsByPlants = response;
          this.userList = this.participantsByPlants.slice();
        }
      },
      (err: any) => {

      }
    );
  }
  imageZoomModal(): void {
    let dialogRef = this.dialog.open(ImageDialogComponent, {
      height: '90%',
      width: '90%',
      data:
        this.data.FileSrc || Constants.BLOB_STORAGE_URL + this.data.UploadFile,
    });
    // this.dialog.open(this.imageZoomModel, { height: '90%', width: '90%' });
  }
  deleteFile(type: any): void {
    if (type === 'pic') {
      this.data.FileSrc = '';
      this.data.UploadFile = '';
      this.ImageSave = new File([''], 'filename');
    } else {
      this.data.DocSrc = '';
      this.data.UploadDoc = '';
      this.fileSave = new File([''], 'filename');
    }
  }
  openFile(type?: any): void {
    if (type === 'pic') {
      this.fileInput.nativeElement.click();
    } else {
      this.fileInputFile.nativeElement.click();
    }
  }
  readFile(event: any, type: any): void {
    this.imageFile = event.target.files[0];
    if (type === 'pic') {
      this.data.UploadFile = this.imageFile;
      this.ImageSave = event.target.files[0];
    } else {
      this.data.UploadDoc = this.imageFile;
      this.fileSave = event.target.files[0];
    }
    const reader = new FileReader();
    if (event.target.files && event.target.files.length) {
      const [file] = event.target.files;
      reader.readAsDataURL(file);
      reader.onload = () => {
        this.imageSrc = reader.result as string;
        if (type === 'pic') {
          this.data.FileSrc = this.imageSrc;
        } else {
          this.data.DocSrc = this.imageSrc;
        }
      };
    }
  }
  downloadPDF() {
    // [href]=" yData.DocSrc || blobStorageUrl + yData.UploadDoc"
    if (this.data.DocSrc) {
      const base64 = this.data.DocSrc;
      var a = document.createElement('a'); //Create <a>
      a.href = base64; //Image Base64 Goes here
      a.target = '_blank';
      a.download = 'file.pdf'; //File name Here
      a.click();
    } else {
      var a = document.createElement('a'); //Create <a>
      a.href = this.blobStorageUrl + this.data.UploadDoc; //Image Base64 Goes here
      a.download = 'file.pdf';
      a.target = '_blank'; //File name Here
      a.click();
    }
  }
  getMinDate(type: any): any {
    if (type === 'Revised') {
      const date = this.data.RevisedDate
        ? this.data.RevisedDate
        : this.data.TargetDate;
      const currentDate = new Date(date);

      const minDateStartFrom = new Date(
        currentDate.setDate(currentDate.getDate() + 1)
      );

      return (current: Date): boolean =>
        differenceInCalendarDays(current, minDateStartFrom) < 0;
    } else if (type === 'Target') {
      const currentDate = new Date();
      const minDateStartFrom = new Date(
        currentDate.setDate(currentDate.getDate())
      );

      return (current: Date): boolean =>
        differenceInCalendarDays(current, minDateStartFrom) < 0;
    }
  }

  // getPlantByGroup(): void {
  //   const key = {
  //     GroupId: this.paramValues.group,
  //   };
  //   this.meetingService.getPlantsData(key).subscribe(
  //     (data: any) => {
  //       this.plants = data.DepartList.filter((p: any) => p.DeptDesc);
  //       this.getFrequencyOnMeeting();
  //       this.getMasterShift();

  //       // this.GetTierMeetingChecklist_Data();
  //       this.calendarPlantId = this.plants[0].DeptId;
  //     },
  //     (error: any) => {
  //       this.toaster.error('Error', error.message);
  //     }
  //   );
  // }

  getPlantByGroup(): void {
    const key = {
      groupCode: this.paramValues.group,
    };
    this.meetingService.getPlantsDataByGroup(key).subscribe(
      (data: any) => {
        this.plants = data;
        // this.filteredPlants = this.plants.slice();
        this.getFrequencyOnMeeting();
        this.getMasterShift();

        // this.GetTierMeetingChecklist_Data();
        this.calendarPlantId = this.paramValues.plant;
      },
      (error: any) => {
        this.toaster.error('Error', error.message);
      }
    );
  }

  getFrequencyOnMeeting(): void {
    this.calendarPlantId = this.paramValues.plant;
    this.setFirstWeek();
  }
  setFirstWeek(): void {
    const dept = this.plants.find(item => item.plantCode === this.paramValues.plant);
    this.firstDayOfWeek = dept ? dept.firstDayOfWeek : 0;
    this.setWeekValue(this.firstDayOfWeek);
  }
  setWeekValue(weekDay: number): void {
    if (weekDay == undefined || weekDay == null || Number.isNaN(weekDay))
      weekDay = 0
    sessionStorage.removeItem('weekDay');
    sessionStorage.setItem('weekDay', weekDay.toString());
    this.datepickerService.getFirstDayOfWeek()
  }
  getMasterShift(): void {
    const key = {
      plantCode: this.paramValues.plant,
    };
    this.meetingService.getMasterShifts(key).subscribe(
      (data) => {
        this.shiftData = data;
        // this.shiftData.forEach((c=>))
        this.shiftData.forEach((element) => {
          element.startTime = new Date().setTime(element.startTime);
          element.endTime = new Date().setTime(element.endTime);
        });
      },
      (error: any) => {
        this.toaster.error('Error', error.error.message);
      }
    );
  }
  UpdateActionPlan(): void {
    this.Status = '';
    this.Status =
      this.editActionPlanForm.value.targetDate &&
        !this.editActionPlanForm.value.revisedDate
        ? 'InProgress'
        : this.editActionPlanForm.value.targetDate &&
          this.editActionPlanForm.value.revisedDate
          ? 'Delayed'
          : 'Open';

    if (this.editActionPlanForm.value.targetDate) {
      this.targetDate = this.editActionPlanForm.value.targetDate;
      this.targetDate = new Date(this.targetDate);
      this.targetDate.setHours(new Date().getHours());
      this.targetDate.setMinutes(new Date().getMinutes());
      this.targetDate.setSeconds(new Date().getSeconds());
    }
    if (this.editActionPlanForm.value.revisedDate) {
      this.RevisedDate = this.editActionPlanForm.value.revisedDate;
      this.RevisedDate = new Date(this.RevisedDate);
      this.RevisedDate.setHours(new Date().getHours());
      this.RevisedDate.setMinutes(new Date().getMinutes());
      this.RevisedDate.setSeconds(new Date().getSeconds());
    }
    if (this.editActionPlanForm.value.completed === 'Yes') {
      this.Status = 'Complete';
      var templateBody = null;
      var plantName = null;

      var plant = this.plants.find(
        // (x) => x.DeptId == this.MeetingMatrixForm.value.plant
        (x) => x.plantCode == this.paramValues.plant
      );
      plantName = plant.DeptDesc;
      var date = null;
      var user = this.userList.find(
        (x) => x.employeeCode == this.editActionPlanForm.value.assignTo
      );
      if (
        this.editActionPlanForm.controls.revisedDate.value >
        this.editActionPlanForm.controls.targetDate.value
      ) {
        date = this.editActionPlanForm.controls.revisedDate.value;
      } else {
        date = this.editActionPlanForm.controls.targetDate.value;
      }
      if (this.editActionPlanForm.controls.verification.value == 'Approved') {
        templateBody =
          `<div style="font-family: Helvetica; display: flex; flex-direction: column;">
        <div style="display: flex;background-color:#1d4ed8; color: white; padding: 2rem">
            <h2 style="margin-right: auto">O3 SMART MANUFACTURING</h2>
            <img src="https://res.cloudinary.com/durdmvneg/image/upload/v1629181792/logo-full_ku1lp4.png" style="display: block; border: 0px; object-fit:contain ;" />
        </div>
        <h2 style="margin-left: auto; margin-right: auto; margin-top: 1rem; font-weight: 800">Action Plan Detail</h2>
        <div style="background-color: #f3f4f6; padding: 1rem; display: flex;">
            <div style="width: 20%;font-weight: 800;">Plant: </div><div style="width: 80%;font-weight: 800;">` +
          plantName +
          `</div>
        </div>
        <table style="margin-top: 1.5rem;">
            <tr>
                <th style="background-color:#e7e5e4; padding: 0.8rem">Action Plan</th>
                <th style="background-color:#e7e5e4; padding: 0.8rem">Created Date</th>
                <th style="background-color:#e7e5e4; padding: 0.8rem">Target Date</th>
                <th style="background-color:#e7e5e4; padding: 0.8rem">Responsible</th>
                <th style="background-color:#e7e5e4; padding: 0.8rem">Status</th>
            </tr>
            <tr>
                <td style='text-align: center'>` +
          this.editActionPlanForm.controls.actions.value +
          `</td>
                <td style='text-align: center'>` +
          moment(this.currentNodeDate).format('DD/MM/YYYY hh:mm:ss') +
          `</td>
                <td style='text-align: center'>` +
          moment(date).format('DD/MM/YYYY hh:mm:ss') +
          `</td>
                <td style='text-align: center'>` +
          user.FullName +
          `</td>
                <td style='text-align: center'>Closed</td>
            </tr>
        </table>
    </div>`;
      } else {
        templateBody =
          `<div style="font-family: Helvetica; display: flex; flex-direction: column;">
        <div style="display: flex;background-color:#1d4ed8; color: white; padding: 2rem">
            <h2 style="margin-right: auto">O3 SMART MANUFACTURING</h2>
            <img src="https://res.cloudinary.com/durdmvneg/image/upload/v1629181792/logo-full_ku1lp4.png" style="display: block; border: 0px; object-fit:contain ;" />
        </div>
        <h2 style="margin-left: auto; margin-right: auto; margin-top: 1rem; font-weight: 800">Action Plan Detail</h2>
        <div style="background-color: #f3f4f6; padding: 1rem; display: flex;">
            <div style="width: 20%;font-weight: 800;">Plant: </div><div style="width: 80%;font-weight: 800;">` +
          plantName +
          `</div>
        </div>
        <table style="margin-top: 1.5rem;">
            <tr>
                <th style="background-color:#e7e5e4; padding: 0.8rem">Action Plan</th>
                <th style="background-color:#e7e5e4; padding: 0.8rem">Created Date</th>
                <th style="background-color:#e7e5e4; padding: 0.8rem">Target Date</th>
                <th style="background-color:#e7e5e4; padding: 0.8rem">Responsible</th>
                <th style="background-color:#e7e5e4; padding: 0.8rem">Status</th>
            </tr>
            <tr>
                <td style='text-align: center'>` +
          this.editActionPlanForm.controls.actions.value +
          `</td>
                <td style='text-align: center'>` +
          moment(this.currentNodeDate).format('DD/MM/YYYY hh:mm:ss') +
          `</td>
                <td style='text-align: center'>` +
          moment(date).format('DD/MM/YYYY hh:mm:ss') +
          `</td>
                <td style='text-align: center'>` +
          user.FullName +
          `</td>
                <td style='text-align: center'>Completed</td>
            </tr>
        </table>
    </div>`;
      }
      var emailParam = {
        Body: templateBody,
        ToEmailAddress: this.currentAssigneeEmail,
        CCEmails: this.currentResponsibleEmail,
        Subject: 'Action Completion',
      };
      this.actionplanService.sendMail(emailParam).subscribe(
        (res) => {
          // this.toaster.success("Mail sent", "Success");
        },
        ({ error }) => {
          this.toaster.error('Cannot Send Mail', 'Error');
        }
      );
    }
    if (this.editActionPlanForm.value.verification === 'Approved') {
      this.Status = 'Closed';
      // fiveWhy.ClosedDate = new Date();
    } else if (this.editActionPlanForm.value.verification === 'Disapproved') {
      this.Status = 'ReOpened';
      // fiveWhy.ActionCompleted = 'No';
      this.editActionPlanForm.get('completed').setValue('No');
    }

    const formdata = new FormData();
    formdata.append('file', this.fileSave);
    formdata.append('image', this.ImageSave);
    formdata.append('closefile', this.closefile);
    const key = {
      actionId: this.data.ID,
      actionName: this.editActionPlanForm.value.actions,
      actionType: this.editActionPlanForm.value.actionType,
      responsible: this.editActionPlanForm.value.assignTo,
      targetDate: this.targetDate ? this.targetDate : null,
      revisedDate: this.RevisedDate ? this.RevisedDate : null,
      ActionCompleted: this.editActionPlanForm.value.completed,
      Verification: this.editActionPlanForm.value.verification,
      remarks: this.editActionPlanForm.value.remarks,
      NewAssignee: this.editActionPlanForm.value.NewAssignee
        ? this.editActionPlanForm.value.NewAssignee
        : null,
      status: this.Status,
      userId: JSON.parse(localStorage.user).UserId,
      rootCause: this.editActionPlanForm.value.rootcause
    };
    formdata.append('values', JSON.stringify(key));
    this.actionplanService.editActionPlan(formdata).subscribe((res: any) => {
      if (res[0].Column1 === 'Updated Successfully') {
        this.toaster.success('Success', `Updated Sucessfully `);
        this.getOverallMeetingActions();
        this.currentDialog.close();
        this.showinput = false;
      }
    });
    // }
  }

  onChangeComplete(): void {
    if (this.editActionPlanForm.value.completed === 'Yes') {
      this.disableVerification = false;
      this.editActionPlanForm.get('verification').setValue('');
    }
  }
}
